import styled from 'styled-components';

export const StyledResetPasswordLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem;
  gap: 1rem;
  align-self: stretch;

  border-radius: ${({ theme }) => theme.radius.small};
  border: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background.main};

  line-break: anywhere;
`;

export const StyledResetPasswordLink = styled.div`
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  display: flex;
  max-width: 85%;
  line-break: anywhere;
`;

export const StyledTooltipWrapper = styled.div`
  display: flex;
  position: relative;

  & > div {
    position: absolute;
    top: -2rem;
    left: -8rem;
  }
`;

export const StyledTooltipContent = styled.div`
  display: flex;
  gap: 0.3rem;
  align-items: center;
  min-width: 2.8rem;
`;
